import React from "react";

const OptionsYearsUntilExpiration = () => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = 0; i < 10; i++) {
    years.push(currentYear + i);
  }
  return (
    <>
      <option disabled value="">
        Ano Venc.
      </option>
      {years.map((year) => (
        <option value={year} key={year}>
          {year}
        </option>
      ))}
    </>
  );
};

export default OptionsYearsUntilExpiration;
